import { render, staticRenderFns } from "./comp_Home-B-ProductsCards.vue?vue&type=template&id=c0394190&scoped=true&"
import script from "./comp_Home-B-ProductsCards.vue?vue&type=script&lang=js&"
export * from "./comp_Home-B-ProductsCards.vue?vue&type=script&lang=js&"
import style0 from "./comp_Home-B-ProductsCards.vue?vue&type=style&index=0&id=c0394190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0394190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
